export const lastPageRecordCount = (totalDocs, page, limit) => {
  const lastRecords = Number((page - 1) * limit) + limit;

  return totalDocs < lastRecords ? totalDocs : lastRecords;
};
